import React, { useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Layout, Row, Col, Card, Typography } from 'antd';
import { FolderOutlined, CommentOutlined, ToolOutlined, BookOutlined, DashboardOutlined, ProjectOutlined, ScheduleOutlined, FileTextOutlined, KeyOutlined, RobotOutlined, AuditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import AuthContext from '../../contexts/authProvider';
import './selectMenu.scss';
import { IS_PRODUCTION, IS_STAGING } from '../../utils/config';

const { Content } = Layout;
const { Title } = Typography;

const SelectMenu = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  if (!user) return <Navigate to="/login" />;

  return (
      <Content className="app-layout-content" style={{ display: 'flex', alignItems: 'center'}}>
        <div style={{ width: '100%', margin: 'auto 0' }}>

        <div className="menu-section">
            <Title level={3} className="menu-section-title">{t('common.menu.knowledgeAndTools')}</Title>
            <Row
              justify="center"
              align="middle"
              gutter={[
                { xs: 16, sm: 16, md: 16, lg: 16 },
                { xs: 16, sm: 16, md: 16, lg: 16 },
              ]}
            >
              {/* Hide FileManager option in STAGING environment */}
              {!IS_STAGING && (
                <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                  <Card className="app-select-menu-item">
                    <div className="app-select-menu-wrap" onClick={() => navigate('/filemanager')}>
                      <div className="icon">
                        <FolderOutlined />
                      </div>
                      <div className="description">{t('common.menu.fileSearch')}</div>
                    </div>
                  </Card>
                </Col>
              )}
              <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                <Card className="app-select-menu-item">
                  <div className="app-select-menu-wrap" onClick={() => navigate('/askquestion')}>
                    <div className="icon">
                      <CommentOutlined />
                    </div>
                    <div className="description">{t('common.menu.askQuestion')}</div>
                  </div>
                </Card>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                <Card className="app-select-menu-item" onClick={() => navigate('/knowledgeBaseManager')}>
                  <div className="app-select-menu-wrap">
                    <div className="icon">
                      <BookOutlined />
                    </div>
                    <div className="description">{t('common.menu.knowledgeBaseManager')}</div>
                  </div>
                </Card>
              </Col>
              {/* <Col xs={12} sm={12} md={12} lg={4} xl={3}>
                <Card className="app-select-menu-item disabled">
                  <div className="app-select-menu-wrap">
                    <div className="icon">
                      <ContainerOutlined />
                    </div>
                    <div className="description">專案資訊管理</div>
                  </div>
                </Card>
              </Col> */}
              <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                <Card className="app-select-menu-item" onClick={() => navigate('/usefulTools')}>
                  <div className="app-select-menu-wrap">
                    <div className="icon">
                      <ToolOutlined />
                    </div>
                    <div className="description">{t('common.menu.usefulTools')}</div>
                  </div>
                </Card>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                <Card className="app-select-menu-item" onClick={() => navigate('/documentParser')}>
                  <div className="app-select-menu-wrap">
                    <div className="icon">
                      <FileTextOutlined />
                    </div>
                    <div className="description">{t('documentParser.menu')}</div>
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
          {/* WIP: PRODUCTION AND STAGING ENVIRONMENT */}
          <div className="menu-section"
            style={{ display: (IS_PRODUCTION || IS_STAGING) ? 'none' : '' }}
          >
            <Title level={3} className="menu-section-title">{t('common.menu.projectManagement')}</Title>
            <Row justify="center" align="middle" style={{ marginBottom: '32px' }} gutter={[
              { xs: 16, sm: 16, md: 16, lg: 16 },
              { xs: 16, sm: 16, md: 16, lg: 16 },
            ]}>
              <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                <Card className="app-select-menu-item">
                  <div className="app-select-menu-wrap" onClick={() => navigate('/project/dashboard')}>
                    <div className="icon">
                      <DashboardOutlined />
                    </div>
                    <div className="description">{t('common.menu.dashboard')}</div>
                  </div>
                </Card>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                <Card className="app-select-menu-item">
                  <div className="app-select-menu-wrap" onClick={() => navigate('/project/management')}>
                    <div className="icon">
                      <ProjectOutlined rotate={270} />
                    </div>
                    <div className="description">{t('common.menu.projectManage')}</div>
                  </div>
                </Card>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                <Card className="app-select-menu-item">
                  <div className="app-select-menu-wrap" onClick={() => navigate('/project/planning')}>
                    <div className="icon">
                      <ScheduleOutlined />
                    </div>
                    <div className="description">{t('common.menu.projectPlanning')}</div>
                  </div>
                </Card>
              </Col>
            </Row>
          </div>

          {/* Settings Section */}
          <div className="menu-section">
            <Title level={3} className="menu-section-title">{t('common.menu.settingsAndManagement')}</Title>
            <Row justify="center" align="middle" style={{ marginBottom: '32px' }} gutter={[
              { xs: 16, sm: 16, md: 16, lg: 16 },
              { xs: 16, sm: 16, md: 16, lg: 16 },
            ]}>
              <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                <Card className="app-select-menu-item">
                  <div className="app-select-menu-wrap" onClick={() => navigate('/settings/tokens')}>
                    <div className="icon">
                      <KeyOutlined />
                    </div>
                    <div className="description">{t('common.menu.personalTokens')}</div>
                  </div>
                </Card>
              </Col>
              {/* System Admin-only menu items */}
              {user?.is_system_admin && (
                <>
                  <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                    <Card className="app-select-menu-item">
                      <div className="app-select-menu-wrap" onClick={() => navigate('/admin/service-accounts')}>
                        <div className="icon">
                          <RobotOutlined />
                        </div>
                        <div className="description">{t('common.menu.serviceAccounts')}</div>
                      </div>
                    </Card>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                    <Card className="app-select-menu-item">
                      <div className="app-select-menu-wrap" onClick={() => navigate('/admin/audit-logs')}>
                        <div className="icon">
                          <AuditOutlined />
                        </div>
                        <div className="description">{t('common.menu.auditLogs')}</div>
                      </div>
                    </Card>
                  </Col>
                </>
              )}
            </Row>
          </div>
        </div>
      </Content>
  );
};

export default SelectMenu;
